import { Component, OnInit, OnDestroy } from '@angular/core';
import Project from 'models/project/project.model';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from 'services/project/project.service';
import User from 'models/user/user.model';
import { UserService } from 'services/user/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';

@Component({
  selector: 'app-add-user-to-project',
  templateUrl: './add-user-to-project.component.html',
  styleUrls: ['./add-user-to-project.component.scss']
})
export class AddUserToProjectComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
